import { render, staticRenderFns } from "./CourseRecord.vue?vue&type=template&id=12396b04"
import script from "./CourseRecord.vue?vue&type=script&lang=js"
export * from "./CourseRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports